<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter">
<header>
<h1 class="topictitle1" id="ma3"><a href="#/nav#nma3"><span class="first_text">Map #1</span></a></h1>
</header>
<div class="fignone" id="id-37210-DarwinStrain_9780062835475_finalforflowing_cHCML_CM_topic_8--fig-2-0-0">
<div class="figbody"><img alt="Map_2_4p.jpg" src="Map2_corrected.jpg"/></div>
</div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Map_2.vue?3a575a29